"use client"

import {motion, type Variants} from "framer-motion";
import Icon from "~/components/ui/Icon";
import LocationIcon from "~/assets/icons/location.svg";
import Link from "next/link";
import Url from "~/assets/icons/url.svg";
import React from "react";

interface Props {
  name: string;
  address: string;
  url?: string | null;
  variant: Variants;
  children?: React.ReactNode;
  visible?: boolean;
}

export default function SubscriberCard({ name, address, url, variant, children, visible }: Props) {
  return (
    <motion.div
      className="w-full rounded-[32px] bg-white p-[40px] shadow-[0_4px_16px_0_rgba(0,0,0,0.08)]"
      variants={variant}
    >
      <Icon visible={visible}>
        <LocationIcon />
      </Icon>
      <div className="flex flex-col">
        <h3 className={"h3 !font-[800] text-primary" + (visible === false ? " opacity-40" : "")}>{name}</h3>
        <div className={"mb-6 text-[16px] font-[400] text-primary" + (visible === false ? " opacity-40" : "")}>
          {address}
        </div>
        {url && (
          <p className={"mt-12" + (visible === false ? " opacity-40" : "")}>
            <Link
              href={url}
              target="_blank"
              className="btn btn-secondary ripple"
            >
              <span className="mr-3">
                <Url />
              </span>
              {url.includes("facebook") ? "Facebook" : "Webové stránky"}
            </Link>
          </p>
        )}
        {children != null && children}
      </div>
    </motion.div>
  );
}
